import { useMemo } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";

export default function ProtectedRoute({ children, role }) {
  const { user } = useAuth();
  const location = useLocation();
  // Stable redirect state to avoid producing a new object on every render.
  const redirectState = useMemo(() => ({ from: location }), [location]);

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center" data-testid="auth-loading">
        <div className="font-mono-fin text-xs tracking-[0.32em] uppercase text-[color:var(--br-text-dim)]">
          Verifica sessione…
        </div>
      </div>
    );
  }

  if (user === false) {
    return <Navigate to="/login" state={redirectState} replace />;
  }

  // Mandatory password change after temp-password issuance. The flag is
  // cleared as soon as the user submits a new password via /change-password.
  // We allow /change-password itself through, otherwise we'd trap the user.
  if (user.must_change_password && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  if (role) {
    const allowedRoles = Array.isArray(role) ? role : [role];
    if (!allowedRoles.includes(user.role)) {
      // logged in but wrong role: send to the right home page for their role
      const dest =
        user.role === "admin"
          ? "/admin"
          : user.role === "introducer"
            ? "/introducer"
            : "/dashboard";
      return <Navigate to={dest} replace />;
    }
  }

  return children;
}
